const API_CALL_TIMEOUT = 6000
const STATUS_CODES = {
	FORBIDDEN: 403,
	FOUND: 302,
};

export {API_CALL_TIMEOUT, STATUS_CODES}